import React, {Component} from 'react';
import CONSTANTS from '../../config/constants'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronDoubleRight} from '@fortawesome/pro-regular-svg-icons';
import pocalImage from '../../assets/images/highscore.png';
import _ from "lodash";

class HighScoreBlock extends Component {
    getContentFieldValue = (fieldDefinitionKey) => {
        const {contentFields} = this.props;
        const data = _.find(contentFields, {fieldDefinitionKey: fieldDefinitionKey});

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }
        return false
    };

    getBlockWidth = () => {
        const {width} = this.props;

        let w = 40;

        if (width && width !== CONSTANTS.BLOCK_DEFAULT_WIDTH) {
            return width;
        } else {
            if (this.getContentFieldValue('Width') && this.getContentFieldValue('Width') !== CONSTANTS.BLOCK_DEFAULT_WIDTH && this.getContentFieldValue('Width') !== w) {
                w = this.getContentFieldValue('Width');
            }
        }

        return w;
    };

    render() {
        const {relatedContents} = this.props;

        const items = relatedContents && relatedContents[0] && relatedContents[0].topUsersHighscore ? relatedContents[0].topUsersHighscore.map(item => {
            return {
                name: `${item.firstName} ${item.lastName}`,
                score: `${item.trainingPoints}p`
            }
        }) : [];

        return (
            <section
                className={"highscore w--" + this.getBlockWidth() + " show--shadow"}>
                <section className="highscore--inner">
                    <div className="inner-wrapper inner-wrapper--highscore">

                        <div className="title-section acms-row">
                            <div className={"acms-col"}>
                                <h3>{this.getContentFieldValue('Title')}</h3>
                            </div>
                            <div className={"acms-col"}>
                                <img src={pocalImage} alt={this.getContentFieldValue('Title')}/>
                            </div>
                        </div>
                        <div className="content-section">
                            <ol>
                                {items.map((highscore, key) => (
                                    <li key={key}>
                                        <em>{highscore.name}</em>
                                        <span>{highscore.score}</span>
                                    </li>
                                ))}
                            </ol>
                            {relatedContents && relatedContents[0] && relatedContents[0].currentUserHighscore &&
                            <p className="your-score">
                                <em>{relatedContents[0].currentUserHighscore.firstName} {relatedContents[0].currentUserHighscore.lastName} (you)</em>
                                <span>{relatedContents[0].currentUserHighscore.trainingPoints}p</span>
                            </p>
                            }
                            <a href="/">Go to learner home<FontAwesomeIcon icon={faChevronDoubleRight}/></a>
                        </div>
                    </div>
                </section>
            </section>
        );
    }
}

export default HighScoreBlock;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/HighScoreBlock.js